import {
  SELECTED_ACCOUNT_KEY,
  SELECTED_SEEK_ACCOUNT_KEY,
} from 'src/constants/userAccountKeys';
import { getItem } from 'src/utils/localStorage';

export const getAdvertiserIds = () => ({
  advertiserId: getItem(SELECTED_ACCOUNT_KEY),
  seekAdvertiserId: getItem(SELECTED_SEEK_ACCOUNT_KEY),
});

export const isValidId = (id: string | null): id is string =>
  Boolean(id && parseInt(id, 10) > 0);
